import React from 'react';

// Encode email pour éviter la scrape par robots
export const encodeEmail = (email) => {
  return btoa(email);
};

// Decode email
export const decodeEmail = (encodedEmail) => {
  try {
    return atob(encodedEmail);
  } catch (error) {
    console.error('Erreur lors du décodage de l\'email', error);
    return '';
  }
};

// Email obfusqué
export const OBFUSCATED_EMAIL = 'Y29udGFjdEBodGFnZmFjaWxpdHkuZnI='; // contact@htagfacility.fr

// Récupérer l'email décodé
export const getContactEmail = () => {
  return decodeEmail(OBFUSCATED_EMAIL);
};

// Créer un lien mailto sécurisé
export const createMailtoLink = () => {
  const email = getContactEmail();
  return `mailto:${email}`;
};

// Afficher l'email de manière lisible (masqué dans le HTML source)
export const EmailDisplay = ({ className = '' }) => {
  const [email, setEmail] = React.useState('');

  React.useEffect(() => {
    setEmail(getContactEmail());
  }, []);

  if (!email) return null;

  return (
    <a href={`mailto:${email}`} className={className}>
      {email}
    </a>
  );
};

export default {
  encodeEmail,
  decodeEmail,
  OBFUSCATED_EMAIL,
  getContactEmail,
  createMailtoLink,
  EmailDisplay
};
